import React, { useEffect, useCallback } from "react";
import { connect } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import FacilityForm from "../../components/maintenance/FacilityForm";
import {
  fetchFacility,
  fetchFacilitySuccess,
  fetchFacilityFailure,
  createFacility,
  createFacilitySuccess,
  createFacilityFailure,
  updateFacility,
  updateFacilitySuccess,
  updateFacilityFailure,
  fetchFacilityTypes,
  fetchFacilityTypesSuccess,
  fetchFacilityTypesFailure,
  fetchMaintenanceLocations,
  fetchMaintenanceLocationsSuccess,
  fetchMaintenanceLocationsFailure,
  clearCurrentFacility,
} from "../../store/maintenance/actions";

const FacilityFormContainer = ({
  facility,
  facilityTypes,
  locations,
  loading,
  error,
  fetchFacility,
  createFacility,
  updateFacility,
  fetchFacilityTypes,
  fetchMaintenanceLocations,
  clearCurrentFacility,
}) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const isEdit = Boolean(id);

  useEffect(() => {
    fetchFacilityTypes();
    fetchMaintenanceLocations();

    if (isEdit) {
      fetchFacility(id);
    }

    return () => {
      clearCurrentFacility();
    };
  }, [id, isEdit, fetchFacility, fetchFacilityTypes, fetchMaintenanceLocations, clearCurrentFacility]);

  const handleSubmit = useCallback(
    async (data) => {
      try {
        if (isEdit) {
          await updateFacility(id, data);
        } else {
          await createFacility(data);
        }
        navigate("/maintenance/facilities");
      } catch (err) {
        console.error("Error saving facility:", err);
      }
    },
    [isEdit, id, createFacility, updateFacility, navigate]
  );

  return (
    <FacilityForm
      facility={facility}
      facilityTypes={facilityTypes}
      locations={locations}
      loading={loading}
      error={error}
      isEdit={isEdit}
      onSubmit={handleSubmit}
    />
  );
};

const mapStateToProps = (state) => ({
  facility: state.maintenance.facilities.current,
  facilityTypes: state.maintenance.facilityTypes.list,
  locations: state.maintenance.locations.list,
  loading: state.maintenance.facilities.loading,
  error: state.maintenance.facilities.error,
});

const mapDispatchToProps = (dispatch) => ({
  fetchFacility: (id) => {
    dispatch(fetchFacility(id)).payload.then(
      (response) => {
        dispatch(fetchFacilitySuccess(response.data));
      },
      (error) => {
        dispatch(fetchFacilityFailure(error.response?.data || error));
      }
    );
  },
  createFacility: (data) => {
    return dispatch(createFacility(data)).payload.then(
      (response) => {
        dispatch(createFacilitySuccess(response.data));
      },
      (error) => {
        dispatch(createFacilityFailure(error.response?.data || error));
        throw error;
      }
    );
  },
  updateFacility: (id, data) => {
    return dispatch(updateFacility(id, data)).payload.then(
      (response) => {
        dispatch(updateFacilitySuccess(response.data));
      },
      (error) => {
        dispatch(updateFacilityFailure(error.response?.data || error));
        throw error;
      }
    );
  },
  fetchFacilityTypes: () => {
    dispatch(fetchFacilityTypes(1, null, null, 9999)).payload.then(
      (response) => {
        dispatch(fetchFacilityTypesSuccess(response.data));
      },
      (error) => {
        dispatch(fetchFacilityTypesFailure(error.response?.data || error));
      }
    );
  },
  fetchMaintenanceLocations: () => {
    dispatch(fetchMaintenanceLocations(1, null, null, 9999)).payload.then(
      (response) => {
        dispatch(fetchMaintenanceLocationsSuccess(response.data));
      },
      (error) => {
        dispatch(fetchMaintenanceLocationsFailure(error.response?.data || error));
      }
    );
  },
  clearCurrentFacility: () => dispatch(clearCurrentFacility()),
});

export default connect(mapStateToProps, mapDispatchToProps)(FacilityFormContainer);
